const materialsArray = [
  'algodão',
  'poliester',
  'moletom',
  'tactel',
  'brim',
  'jeans',
  'plástico',
  'térmico',
  'couro',
  'xita',
  'tricoline',
  'cetim',
];

export default materialsArray;
